import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import LoginContainer from './containers//loginContainer';
import DonationSuccess from './components/DonationSuccess';
// import DonationFailure from './components/DonationFailure';
import DonationInProgressContainer from './containers/DonationInProgressContainer';
import DonationFailureContainer from './containers/DonationFailureContainer';
import VerifiedContainer from './containers/VerifiedContainer';
import ConfirmContainer from './containers/ConfirmContainer';
import { saveLikeID } from './actions';
import getParameterByName from './utils/querystring';

import './App.css';

class App extends Component { // eslint-disable-line react/prefer-stateless-function

  componentWillMount() {
    this.props.saveTinabaLikeID();
  }

  render() {
    let shownRoute = <LoginContainer />;
    if (this.props.route === 'DonationInProgress') {
      shownRoute = <DonationInProgressContainer />;
    } else if (this.props.route === 'LoginForm') {
      shownRoute = <LoginContainer />;
    } else if (this.props.route === 'DonationSuccess') {
      shownRoute = <DonationSuccess />;
    } else if (this.props.route === 'DonationFailure') {
      shownRoute = <DonationFailureContainer />;
    } else if (this.props.route === 'Verified') {
      shownRoute = <VerifiedContainer />;
    } else if (this.props.route === 'Confirm') {
      shownRoute = <ConfirmContainer />;
    } else {
      shownRoute = 'Questa richiesta è scaduta!';
    }

    return (
      <div className="app">
        { shownRoute }
      </div>
    );
  }
}
App.propTypes = {
  route: PropTypes.string.isRequired,
  saveTinabaLikeID: PropTypes.function
};

const mapStateToProps = state => ({
  route: state.route
});

const mapDispatchToProps = dispatch => ({
  saveTinabaLikeID: () => {
    dispatch(saveLikeID(getParameterByName('tinabaID'), getParameterByName('url')));
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/App.prod.jsx
 **/